import { getBotById, getRephrasedFlow } from '../../services/bot';
import { httpRequest } from '../../services/network';
import UAParser from 'ua-parser-js';
import { STORE } from '../../store';
import { updateEnvironment } from '../../actions/environment.action';
import { initializeAI, initializeMessages, loadMessages, loadRevisitFlow, updateFlow, updateMeta } from '../../actions';
import { addInstallation, updateUUID } from '../../services/saveResponse';
import { createSocketConnection } from '../../services/socket';
import { updateConfiguration } from '../../actions/configuration.action';
import { updateDesign } from '../../actions/design';
import { launcherIconAppearanceSound } from '../../services/notification-handler';
import { initializeGTM } from '../GoogleTagManager';

// FIXME: Add detailed comments on what does this do
// FIXME: Create separate MessengerInitializer for landing page and launcher icon, keep common code in one file and dedictaed data in other files. This is to reduce bundle size

export const initializeLauncherIcon = () => {
	const bot = (window as any).parent.BotPenguinData;

	if (bot && bot.configuration && bot.configuration.generalSettings && bot.configuration.generalSettings.notificationSound) {
		const notificationSound = bot.configuration.generalSettings.notificationSound;
		launcherIconAppearanceSound(notificationSound);
	}

	setBotDetails(bot);
	window.parent.postMessage({
		origin: 'BotPenguin',
		action: 'rendered'
	}, '*');
}

export const initializeLandingPage = async (botId: string, userId: string) => {
	try {
		const bot = await getBotById(botId, userId);
		setBotDetails({ ...bot, isLanding: true });
		localStorage.setItem('BotPenguin_User_uuid', bot.uuid);
		localStorage.setItem('BotPenguin_Landing_Page', JSON.stringify(bot));
		
		// Initialize google tag manager in the DOM
		initializeGTM(bot);

	} catch (error) {
		// FIXME: On error redirect this to the NotFound component
		console.log(error);
	}
}

export const setBotDetails = async (bot: any) => {
	try {

		initialiseEnvironment(bot);

		if (bot && bot.shouldFetchRephrasedFlow) {
			getRephrasedFlow(bot._id, bot.flows[0]._id, 'main');
			STORE.dispatch(updateEnvironment({ shouldFetchRephrasedFlow: bot.shouldFetchRephrasedFlow }));
		}

		if (bot && bot.shouldFetchRephrasedRevisitFlow && bot.flows[0]._id !== bot.revisitFlow?._id) {
			getRephrasedFlow(bot._id, bot.revisitFlow._id, 'revisit');
			STORE.dispatch(updateEnvironment({ shouldFetchRephrasedRevisitFlow: bot.shouldFetchRephrasedRevisitFlow }));
		}
		// setBotMessages(bot);
		addInstallation();
		getIpDetails()
			.then((result) => {
				// FIXME: I guess there will be a logic here to check if this chatbot is active on this country or not just like done in launcher icon
				createSocketConnection({
					...result,
					...getDeviceDetails(),
					location: result?.city,
					user: bot._user,
					uuid: bot.uuid
				});
				updateUUID({
					...result,
					...getDeviceDetails(),
					location: result?.city,
					url: window.location.href
				}).catch(() => console.log('Error creating uuid'));
			})
			.catch((error) => {
				console.log('Error', error);
			});


		setTimeout(() => {
			if (bot && bot.design && bot.design.customCSS) {
				const styleElement = document.createElement("style");
				styleElement.textContent = bot.design.customCSS;
				document.head.appendChild(styleElement);

			}
		}, 100)

	} catch (error) {
		console.log(error, "Error fetching bot details");
	}
}
/**
 * Initialise Environment State
 * TODO: define type for bot
 */
export const initialiseEnvironment = (bot: any) => {
	const botpenguinData = bot;
	const activeTabCount = parseInt(localStorage.getItem('tabCount') || '0');
	let localMessages: any = botpenguinData.configuration?.generalSettings?.userChatRetention === 'forever' || activeTabCount
		? localStorage.getItem(`BotPenguin-${botpenguinData._id}`)
		: sessionStorage.getItem(`BotPenguin-${botpenguinData._id}`);

	if (localMessages) {
		try {
			localMessages = JSON.parse(localMessages).messages || [];
		} catch (e) {
			localMessages = [];
		}
	}

	const shouldClearChat = botpenguinData.configuration?.chatMenu?.clearChatOnReload || false;
	const clearChatOnBrowserReload = sessionStorage.getItem('clearChatOnBrowserReload') && shouldClearChat;
	// Set initialMessages based on navigation type and restartChatOnReload setting
	const initialMessages = clearChatOnBrowserReload ? [] : localMessages;
	sessionStorage.setItem('clearChatOnBrowserReload', 'true')
	STORE.dispatch(initializeMessages(initialMessages ?? []));

	STORE.dispatch(updateEnvironment({
		_id: botpenguinData._id,
		_user: botpenguinData._user,
		_agency: botpenguinData._agency,
		activeQuestion: null,
		activeFlow: botpenguinData.flows[0].id,
		preview: botpenguinData.preview || false,
		embedded: botpenguinData.embedded || false,
		refresh: true,
		typing: false,
		pause: false,
		activeQuestionType: initialMessages?.[initialMessages.length - 1]?.type || 'statement',
		skip: false,
		back: false,
		dateTime: false,
		uuid: botpenguinData.uuid,
		lastQuestion: '',
		profile: botpenguinData.profile || '',
		plan: botpenguinData.plan || '',
		liveChat: false,
		isLanding: botpenguinData.isLanding,
		whitelabel: botpenguinData.whitelabel || {},
		chatRequestAccepted: false,
		chatRequestRejected: false,
		_chatWindowUser: botpenguinData._chatWindowUser,
		agentId: undefined,
		socketDisconnected: false,
		installations: botpenguinData.installations || [],
		agencyData: botpenguinData.agency || {},
		chatMenu: botpenguinData.configuration.chatMenu,
		activeInput: botpenguinData.configuration.chatMenu?.voiceSupport?.isEnabled &&
			botpenguinData.configuration.chatMenu?.voiceSupport?.isDefault ? 'voice' : 'chat',
		_flow: botpenguinData.flows[0]._id,
		isResponseStreamingEnabled: botpenguinData.isResponseStreamingEnabled ?? false,
		ai: {
      streaming: false,
      sequenceBuffer: {},
      nextExpectedSequence: 0,
      lastExpectedSequence: -1,
    },
		isVoiceOutputEnabled: false,
		audioInput: {
      isMicOn: false,
      isListening: false
    }
	}));

	STORE.dispatch(updateFlow([...bot.flows]));
	/**
	 * Author: Suraj Kumar
	 * Dated: 10 October 2024
	 * Description: 
	 * The Revisit Flow is triggered when the user clicks the restart chat button. If the 
	 * Revisit Flow is not available, the default flow will be loaded instead.
	 */
	STORE.dispatch(loadRevisitFlow(bot.revisitFlow ? bot.revisitFlow : bot.flows[0]));
	STORE.dispatch(updateConfiguration({ ...bot.configuration }));
	STORE.dispatch(updateDesign({
		...bot.design,
		name: bot.name
	}));
	STORE.dispatch(initializeAI({ messages: bot.ai.messages || {}, ...(!!bot.threadId && { threadId: bot.threadId || '' }), ...(!!bot?.ai?._persona && { persona: { _id: bot.ai._persona } }) }));

}

function getDeviceDetails() {
	const parser = new UAParser();
	const ua = parser.getResult();
	return {
		operatingSystem: ua.os.name + ' ' + ua.os.version,
		device: (ua.device.type || 'Desktop') + `(${(ua.device.vendor || '') + ' ' + (ua.device.model || '')})`,
		browser: ua.browser.name + ' ' + ua.browser.version
	};
}

const fetchIPWithRetry = async (retries = 5, delay = 1000) => {

	for (let i = 0; i < retries; i++) {
		try {

			const response: any = await httpRequest('GET', `https://api.botpenguin.com/meta/ip?via=messengerV2&uuid=${localStorage.getItem('BotPenguin_User_uuid')}`, undefined);

			if (!response || !(response.city || response.country || response.ip)) {
				throw new Error(response?.message || 'Failed to fetch IP details');
			}

			return response;
		} catch (error) {
			if (i === retries - 1) {
				return undefined;
			}
			// Console is kept by intention
			console.log(`Retrying request... attempt ${i + 1}`,);
			console.log(error);

			// Delay before retrying
			await new Promise(resolve => setTimeout(resolve, delay));
		}
	}

	return undefined;
};

export const getIpDetails = async () => {
	try {

		let metaLocation: any = localStorage.getItem('BotPenguin-location');

		if (metaLocation) {

			try {
				metaLocation = JSON.parse(metaLocation);
			} catch (e) {
				metaLocation = await fetchIPWithRetry();
				localStorage.setItem('BotPenguin-location', JSON.stringify(metaLocation));
			}

		} else {
			metaLocation = await fetchIPWithRetry();
			localStorage.setItem('BotPenguin-location', JSON.stringify(metaLocation));
		}

		STORE.dispatch(updateMeta({ ...metaLocation }));
		return metaLocation;

	} catch (error) {
		console.log(error);
	}
}

/**
 * 1. check if BotPenguin Data exists in the parent
 * 2. If it does check for messages in local or session storage based on settings
 * 3. Assign empty array if BotPenguin Data is missing from parent
 * 4. Check if the window is landing page window, if yes then just search local or session storage for messages storage
 */
export const setBotMessages = (bot: any) => {
	let localMessages = [];

	if ((window as any).parent.BotPenguinData || bot) {
		const botData = (window as any).parent?.BotPenguinData || bot;
		const storageKey = `BotPenguin-${botData._id}`;
		const messages = botData.configuration?.generalSettings?.userChatRetention === 'forever'
			? localStorage.getItem(storageKey)
			: sessionStorage.getItem(storageKey);

		localMessages = messages ? JSON.parse(messages).messages : [];
	}
	STORE.dispatch(loadMessages(localMessages));
}
